import React, { useState, useContext, useEffect } from "react";
import "./dashboard.css";
import { AuthContext } from "./util/api";
import { useNavigate } from "react-router-dom";
import Profile from "./dashboard_component/profile";
import Blog from "./dashboard_component/blog";
import SocialLinks from "./dashboard_component/socialLinks";
import AttendancePage from "./attendance/AttendancePage";


export default function Dashboard() {

    const { User, token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("social");



 

    useEffect(() => {
        // Fetch user data or perform any necessary side effects

        if (token === "" || token === null || User == null || User === "") {
            // Redirect to login or show an alert
            navigate("/login");

        }
    }, []);

    return (
        <section style={{ marginTop: "2.5cm" }}>
            <div className="dashboard">

                {/* Top Cards Navigation */}
                <div className="top-cards">


                      <div
                        className={`nav-card ${activeTab === "social" ? "active" : ""}`}
                        onClick={() => setActiveTab("social")}
                    >
                        📝 Our Social Links
                    </div>

                         <div
                        className={`nav-card ${activeTab === "attendance" ? "active" : ""}`}
                        onClick={() => setActiveTab("attendance")}
                    >
                       📝  Attendance
                    </div>


                      <div
                        className={`nav-card ${activeTab === "profile" ? "active" : ""}`}
                        onClick={() => setActiveTab("profile")}
                    >
                        👤 Profile
                    </div>

                  

                  


                     
                </div>

                {User != null &&

                    <div className="main">

                        {/* PROFILE SECTION */}
                        {activeTab === "profile" && (
                            <div className="card fade-in">
                                <Profile />
                            </div>
                        )}

                        {/* BLOG SECTION */}
                        {activeTab === "social" && (
                            <>
                                <SocialLinks/>
                            </>
                        )}



                         {activeTab === "attendance" && (
                            <>
                                <AttendancePage />
                            </>
                        )}


                    </div>

                }
            </div>
        </section>
    );
}
